import env from '../config/env';
import service from '../api/channelTransaction.service';
import permission from '../api/permissions.service';

//constants
const channelTransaction = {
    securityPermission: null,
    channelTransactions: [],
    channelTransactionAdd: null,
    responseChannelTransaction: null,
    errorResponse: ''
}
//types
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LIST_CHANNEL_TRANSACTION = 'LIST_CHANNEL_TRANSACTION';
const ADD_CHANNEL_TRANSACTION = 'ADD_CHANNEL_TRANSACTION';
const UPDATE_CHANNEL_TRANSACTION = 'UPDATE_CHANNEL_TRANSACTION';
const DELETE_CHANNEL_TRANSACTION = 'DELETE_CHANNEL_TRANSACTION';
const ERROR_RESPONSE = 'ERROR_CHANNEL_TRANSACTION';
//reducer
export default function channelTransactionReducer(state = channelTransaction, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LIST_CHANNEL_TRANSACTION:
            return { ...state, channelTransactions: action.payload };
        case ADD_CHANNEL_TRANSACTION:
            return { ...state, channelTransactionAdd: action.payload };
        case ERROR_RESPONSE:
            return { ...state, errorResponse: action.payload };
        default:
            return { ...state };
    }
}

export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.channelTransaction,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const findChannelTransactions = () => async (dispatch) => {
    const response = await service.getChannelTransactions().then((r) => { return r.data });
    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    channelId: element.channel.split("-")[0],
                    channel: element.channel.split("-")[1],
                    collectingEntityId: element.channel.split("-")[2],
                    collectingEntity: element.channel.split("-")[3],
                    typeEntityId: element.type.split("-")[0],
                    typeEntity: element.type.split("-")[1],
                    timeExpiration: element.expirationTime
                });
            });
        } else {
            data.push({
                code: response.code,
                message: response.message
            })
            dispatch({
                type: ERROR_RESPONSE,
                payload: response,
            });
        }
    }
    dispatch({
        type: LIST_CHANNEL_TRANSACTION,
        payload: data
    });

    return data;
}
export const findByEntity = (entity) => async (dispatch) => {
    let response;
    if (entity === 0) {
        response = [];

    } else {
        response = await service.findByEntity(entity).then((r) => {
            return r.data
        })
    }
    dispatch({
        type: LIST_CHANNEL_TRANSACTION,
        payload: response
    });
    return response;
}
export const clearData = ( ) => async (dispatch) => {
    dispatch({
        type: LIST_CHANNEL_TRANSACTION,
        payload: []
    });
}

export const saveChannelTransaction = (channelTransactionData) => async (dispatch) => {
    const response = await service.saveChannelTransaction(channelTransactionData).then((r) => { return r });
    dispatch({
        type: ADD_CHANNEL_TRANSACTION,
        payload: response
    });
    return response;
}

export const updateChannelTransaction = (channelTransactionData) => async (dispatch) => {
    const response = await service.updateChannelTransaction(channelTransactionData).then((r) => { return r });
    dispatch({
        type: UPDATE_CHANNEL_TRANSACTION,
        payload: response
    });
    return response;
}

export const deleteChannelTransaction = (channelTransactions) => async (dispatch) => {
    const response = await service.deleteChannelTransaction(channelTransactions).then((r) => { return r });

    dispatch({
        type: DELETE_CHANNEL_TRANSACTION,
        payload: response
    });
    return response;
}